import { mapGetters, mapMutations } from 'vuex';

export default {
	mounted() {
		for (let index = 1; index < this.getCalculation.real_estate.inhabitants; index++) {
			//this.nextInsureds.push(index + 1);
			this.insureds.push(index + 1);
		}
	},
	data() {
		return {
			insureds: [1],
			nextInsureds: [],
		};
	},
	computed: {
		...mapGetters(['getCalculation']),
		hasInsureds() {
			return _.map(
				_.filter(this.getSelectedOffer?.insurance_events, insurance_event => insurance_event.included),
				filtered => filtered.name,
			).includes('Balesetbiztosítás');
		},
		comutedInsuredsFields() {
			return index => {
				return _.mapValues(this.fields.insuredsData, insuredsData => {
					return {
						...insuredsData,
						refGroup: `baseData-insuredsData-${index}`,
					};
				});
			};
		},
	},
	methods: {
		...mapMutations('contracting', ['deleteInsuredsData']),
		handleAddInsureds() {
			if (this.insureds.length < 5) {
				this.insureds.push(this.nextInsureds.shift());
			}
		},
		handleDelete(index) {
			this.nextInsureds.push(index);
			this.nextInsureds.sort();
			const key = this.insureds.findIndex(insured => insured === index);
			this.insureds.splice(key, 1);
			this.deleteInsuredsData(index);
		},
	},
};
